export function extentMimeTypesWithJPEG(mimeTypes) {
  const extendedMimeTypes = [...mimeTypes];
  if (mimeTypes.includes('image/jpeg') && !mimeTypes.includes('image/jpg')) extendedMimeTypes.push('image/jpg');
  if (mimeTypes.includes('image/jpg') && !mimeTypes.includes('image/jpeg')) extendedMimeTypes.push('image/jpeg');

  return extendedMimeTypes;
}
